import { Vehicule } from '../../../../shared/types/game';
import { VehiculeConfig, FonctionArmement, Competence, PersonnelConfig } from '../../../../shared/types/config';
import { getApiBaseUrl } from '../../../../core/config/api';

/** Résultat de loadVehiculeDetails — données affichées dans la modale de détails. */
export interface VehiculeDetailsLoadResult {
  vehiculeConfigDetails: VehiculeConfig | null;
  fonctionsArmement: FonctionArmement[];
  competences: Competence[];
  personnelConfigs: PersonnelConfig[];
}

/**
 * Charge en parallèle les configs nécessaires pour afficher la modale détails véhicule :
 * config_vehicle correspondant + fonctions armement + compétences + personnel.
 * Extrait de BuildingVehiculesTab.tsx.
 */
export async function loadVehiculeDetails(
  vehicule: Vehicule,
  token: string
): Promise<VehiculeDetailsLoadResult> {
  const result: VehiculeDetailsLoadResult = {
    vehiculeConfigDetails: null,
    fonctionsArmement: [],
    competences: [],
    personnelConfigs: [],
  };

  try {
    const [vehiculesRes, fonctionsRes, competencesRes, personnelRes] = await Promise.all([
      fetch(`${getApiBaseUrl(true)}/config/vehicules`, {
        headers: { Authorization: `Bearer ${token}` },
      }),
      fetch(`${getApiBaseUrl(true)}/config/fonctions-armement`, {
        headers: { Authorization: `Bearer ${token}` },
      }),
      fetch(`${getApiBaseUrl(true)}/config/competences`, {
        headers: { Authorization: `Bearer ${token}` },
      }),
      fetch(`${getApiBaseUrl(true)}/config/personnel`, {
        headers: { Authorization: `Bearer ${token}` },
      }),
    ]);

    if (vehiculesRes.ok) {
      const vehiculesData = await vehiculesRes.json();
      if (vehiculesData.success && Array.isArray(vehiculesData.data)) {
        const config =
          vehiculesData.data.find(
            (c: VehiculeConfig) =>
              vehicule.config_vehicle_id != null &&
              c.id != null &&
              c.id === vehicule.config_vehicle_id
          ) ||
          vehiculesData.data.find(
            (c: VehiculeConfig) => c.nom === vehicule.nom || c.type === vehicule.type
          );
        if (config) result.vehiculeConfigDetails = config;
      }
    }

    if (fonctionsRes.ok) {
      const fonctionsData = await fonctionsRes.json();
      if (fonctionsData.success && Array.isArray(fonctionsData.data)) {
        result.fonctionsArmement = fonctionsData.data;
      }
    }

    if (competencesRes.ok) {
      const competencesData = await competencesRes.json();
      if (competencesData.success && Array.isArray(competencesData.data)) {
        result.competences = competencesData.data;
      }
    }

    if (personnelRes.ok) {
      const personnelData = await personnelRes.json();
      if (personnelData.success && Array.isArray(personnelData.data)) {
        result.personnelConfigs = personnelData.data;
      }
    }
  } catch (error) {
    console.error('Erreur lors du chargement des détails:', error);
  }

  return result;
}
